(function () {

  const main_content = document.querySelectorAll('.content-for-layout');
  const about_us = document.querySelectorAll('.about-us');
  const br = document.querySelectorAll('.product__description br');
  const td = document.querySelectorAll('.product__description td');
  //const info_popup = document.querySelectorAll('.js-info-popup');
  const close_button = document.querySelectorAll('.js-info-close');
  const main_page = document.querySelectorAll('#shopify-section-template--17678567440638__custom_liquid_zq37GA');
  const header_inline_menu = document.querySelectorAll('.header__inline-menu');
  const mega_menu = document.querySelectorAll('.mega-menu');
  const link_text = document.querySelectorAll('.header__menu-item.link--text');
  const mega_menu_content = document.querySelectorAll('.mega-menu__content');
  const header_item = document.querySelectorAll('.mega-menu .header__menu-item');
  const header_item_active = document.querySelectorAll('.header__active-menu-item');
  const product_grid = document.querySelectorAll('#product-grid');
  const button_large = document.querySelectorAll('.filter-tile__button--large');
  const button_small = document.querySelectorAll('.filter-tile__button--small');

  /* about-us page */

  if (about_us[0]) {
    main_content[0].classList.add('js-about-us');
  }
  
  /* hide empty td */

  for (let i = 0; i < br.length; i++) {
    let parent = br[i].parentNode;
    if (parent.childNodes.length == 1) {
      parent.style.display = 'none';
    }
  }

  for (let i = 0; i < td.length; i++) {
    let parent = td[i].parentNode;
    if (td[i].innerHTML.replace(/\&nbsp;/g, '') == '') {
      parent.style.display = 'none';
    }
  }

  /* get cookie */

  function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
              return true;
          }
      }
      return false;
  }

  /* set cookie */

  function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      var expires = "expires="+d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  
  /* collection page tiles */
  
  if (product_grid[0]) {
    button_large[0].addEventListener('click', function(e) {
      e.preventDefault();
      e.target.classList.add('js-tile-active');
      button_small[0].classList.remove('js-tile-active');
      product_grid[0].classList.add('js-tile-large');
    });
    button_small[0].addEventListener('click', function(e) {
      e.preventDefault();
      e.target.classList.add('js-tile-active');
      button_large[0].classList.remove('js-tile-active');
      product_grid[0].classList.remove('js-tile-large');
    });
  }
  
  /* close button 
  
  for (let i = 0; i < close_button.length; i++) {
    close_button[i].addEventListener('click', function(e) {
      e.preventDefault();
      info_popup[0].classList.remove('is-active');
      document.body.classList.remove('js-popup-open');
    });
  }*/

  /* show popup on main page 

  if (!getCookie('visitedHomePage')) {
    if (main_page[0]) {
      window.setTimeout(function(){
        info_popup[0].classList.add('is-active');
        document.body.classList.add('js-popup-open');
        setCookie('visitedHomePage', true, 365); // Set the cookie to expire after 365 days
      }, 2500);
    }
  }*/

  /* open menu */

  for (let i = 0; i < link_text.length; i++) {
    link_text[i].addEventListener('mouseenter', function(e) {
      e.preventDefault();
      for (let i = 0; i < mega_menu.length; i++) {
        removeMenu(i);
      }
    });
  }
  
  for (let i = 0; i < mega_menu.length; i++) {
    mega_menu[i].insertAdjacentHTML('beforeend', '<div class="mega-menu__overlay"></div>');
    mega_menu[i].addEventListener('mouseenter', function(e) {
      e.preventDefault();
      for (let i = 0; i < mega_menu.length; i++) {
        removeMenu(i);
      }
      setMenu(i);
    });
    document.querySelectorAll('.mega-menu__overlay')[i].addEventListener('click', function(e) {
      e.preventDefault();
      removeMenu(i);
    });
    mega_menu_content[i].addEventListener('mouseleave', function(e) {
      e.preventDefault();
      removeMenu(i);
    });
  }

  function setMenu(i) {
    mega_menu[i].setAttribute('open', 'true');
    header_item[i].setAttribute('aria-expanded', 'true');
    header_item[i].classList.add('js-menu-active');
    header_inline_menu[0].classList.add('js-menu-inline');
  }
  
  function removeMenu(i) {
    mega_menu[i].removeAttribute('open');
    header_item[i].removeAttribute('aria-expanded');
    header_item[i].classList.remove('js-menu-active');
    header_inline_menu[0].classList.remove('js-menu-inline');
  }

}());


/* Appointment script */
/* Calendly Widget Loader */